import { Routes, Route } from 'react-router-dom';
import { QuestionnaireProvider } from './contexts/QuestionnaireContext';
import Layout from './components/shared/Layout';
import Home from './pages/Home';
import Questionnaire from './pages/Questionnaire';
import Results from './pages/Results';
import Education from './pages/Education';
import Resources from './pages/Resources';

function App() {
  return (
    <QuestionnaireProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/questionnaire" element={<Questionnaire />} />
          <Route path="/results" element={<Results />} />
          <Route path="/education" element={<Education />} />
          <Route path="/education/:slug" element={<Education />} />
          <Route path="/resources" element={<Resources />} />
        </Routes>
      </Layout>
    </QuestionnaireProvider>
  );
}

export default App;
